export enum AssetsPageObjectModel {
  AddButton = 'assetsPageAddButton',
  DataGridWrapper = 'assetsPageDataGridWrapper',
  DragDropUpload = 'drag-drop-upload',
  ZeroStateUpload = 'zero-state-upload',
  RefreshContentsButton = 'refresh-contents-button',
  SectionHeader = 'assets-page-section-header',
  FolderBreadcrumbs = 'assets-page-folder-breadcrumbs',
  BulkDeleteButton = 'bulk-delete-button',
  BulkDeleteModal = 'bulk-delete-modal',
  BulkReprocessModal = 'bulkReprocessModal',
  BulkReprocessButton = 'bulk-reprocess-button',
}
